@let ibanSwift =
  {
    pattern: 'exchange.dialog.pattern' | translate,
  };

@let errors =
  {
    pattern: 'exchange.dialog.onlyAllowedSymbols' | translate,
  };

@let alphanumeric =
  {
    pattern: 'exchange.dialog.alphanumeric' | translate,
  };

<form class="kr-exchange-set-crypto-fiat-iban" [formGroup]="form()">
  <div class="kr-exchange-set-crypto-fiat-iban__row">
    <fu-simple-input
      formControlName="iban"
      data-testid="exchange_crypto_fiat_iban"
      [errorDictionary]="ibanSwift"
      class="fr-width-100"
      [placeholder]="'exchange.dialog.enterOrSelect' | translate"
      [label]="'exchange.dialog.iban' | translate" />

    <fu-simple-input
      formControlName="beneficiaryName"
      data-testid="exchange_crypto_fiat_beneficiary_beneficiary_name"
      [errorDictionary]="errors"
      class="fr-width-100"
      [placeholder]="'exchange.dialog.beneficiaryName' | translate"
      [label]="'exchange.dialog.beneficiaryName' | translate" />
  </div>

  <div class="kr-exchange-set-crypto-fiat-iban__row">
    <fu-simple-input
      formControlName="BICOrSWIFTCode"
      data-testid="exchange_crypto_fiat_bic_or_swift_input"
      [errorDictionary]="ibanSwift"
      class="fr-width-100"
      [placeholder]="
        (form().controls.transferType.value === 'sepa'
          ? 'exchange.dialog.bicCode'
          : 'exchange.dialog.bicSwift'
        ) | translate
      "
      [label]="
        (form().controls.transferType.value === 'sepa'
          ? 'exchange.dialog.bicCode'
          : 'exchange.dialog.bicSwift'
        ) | translate
      " />

    <fu-simple-input
      formControlName="incorporateNum"
      data-testid="exchange_crypto_fiat_incorporate_number_input"
      [errorDictionary]="alphanumeric"
      class="fr-width-100"
      [placeholder]="'exchange.dialog.incorporateNumber' | translate"
      [label]="'exchange.dialog.incorporateNumber' | translate" />
  </div>

  <div class="kr-exchange-set-crypto-fiat-iban__row">
    <div class="kr-exchange-set-crypto-fiat-iban__column">
      <fu-text-area
        formControlName="reference"
        data-testid="exchange_crypto_fiat_reference_input"
        [errorDictionary]="errors"
        class="fr-width-100"
        [maxLength]="140"
        [rows]="form().controls.transferType.value === 'swift' ? 3 : 5"
        [placeholder]="'exchange.dialog.reference' | translate"
        [label]="'exchange.dialog.reference' | translate" />

      @if (form().controls.transferType.value === 'swift') {
        <fu-simple-input
          [errorDictionary]="ibanSwift"
          formControlName="correspondentBankBICOrSWIFTCode"
          data-testid="exchange_crypto_fiat_correspondent_bic_or_swift_input"
          class="fr-width-100"
          [placeholder]="'exchange.dialog.bicSwiftCode' | translate"
          [label]="'exchange.dialog.bicSwiftCode' | translate" />
      }
    </div>

    <fu-text-area
      formControlName="beneficiaryAddress"
      data-testid="exchange_crypto_fiat_beneficiary_address_input"
      [errorDictionary]="errors"
      class="fr-width-100"
      [class]="
        form().controls.transferType.value === 'swift'
          ? 'kr-exchange-set-crypto-fiat-iban__height-144'
          : null
      "
      [maxLength]="105"
      [placeholder]="'exchange.dialog.beneficiaryAddress' | translate"
      [label]="'exchange.dialog.beneficiaryAddress' | translate" />
  </div>

  @if (form().controls.transferType.value === 'swift') {
    <div class="kr-exchange-set-crypto-fiat-iban__row">
      <fu-simple-input
        formControlName="correspondentBankName"
        data-testid="exchange_crypto_fiat_correspondent_bank_name_input"
        [errorDictionary]="errors"
        class="fr-width-100"
        [placeholder]="'exchange.dialog.correspondentBankName' | translate"
        [label]="'exchange.dialog.correspondentBankName' | translate" />

      <fu-simple-input
        formControlName="beneficiaryBankName"
        data-testid="exchange_crypto_fiat_beneficiary_bank_name_input"
        [errorDictionary]="errors"
        class="fr-width-100"
        [placeholder]="'exchange.dialog.beneficiaryBankName' | translate"
        [label]="'exchange.dialog.beneficiaryBankName' | translate" />
    </div>
  }

  @if (form().controls.transferType.value === 'swift') {
    <div class="kr-exchange-set-crypto-fiat-iban__row">
      <fu-text-area
        formControlName="correspondentBankAddress"
        data-testid="exchange_crypto_fiat_correspondent_bank_address_input"
        [errorDictionary]="errors"
        class="fr-width-100"
        [maxLength]="105"
        [rows]="3"
        [placeholder]="'exchange.dialog.correspondentBankAddress' | translate"
        [label]="'exchange.dialog.correspondentBankAddress' | translate" />

      <fu-text-area
        formControlName="beneficiaryBankAddress"
        data-testid="exchange_crypto_fiat_beneficiary_bank_address_input"
        [errorDictionary]="errors"
        class="fr-width-100"
        [maxLength]="105"
        [rows]="3"
        [placeholder]="'exchange.dialog.beneficiaryBankAddress' | translate"
        [label]="'exchange.dialog.beneficiaryBankAddress' | translate" />
    </div>
  }

  <!--  <fu-checkbox-->
  <!--    formControlName="saveAccountDetails"-->
  <!--    [label]="'exchange.dialog.saveAccountDetailsForLater' | translate" />-->
</form>
